
export default {
  formatDate(d, formatType) {
    const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
    const month = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
    if (formatType === 'short') {
      return `${day}/${month}`;
    }
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  },
  removeAccents(str) {
    const mapAccents = {
      a: 'á|å|à|ã|â|ä|À|Å|Á|Ã|Â|Ä',
      e: 'é|è|ê|ë|É|È|Ê|Ë',
      i: 'í|ì|î|ï|Í|Ì|Î|Ï',
      o: 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
      u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
      c: 'ç|Ç',
      n: 'ñ|Ñ',
      0: 'ø',
    };
    for (const pattern of Object.entries(mapAccents)) {
      str = str.replace(new RegExp(pattern[1], 'g'), pattern[0]);
    }
    return str;
  },
};
